import { render, staticRenderFns } from "./ztomIndexAll.vue?vue&type=template&id=20efeff6&scoped=true&"
import script from "./ztomIndexAll.vue?vue&type=script&lang=js&"
export * from "./ztomIndexAll.vue?vue&type=script&lang=js&"
import style0 from "./ztomIndexAll.vue?vue&type=style&index=0&id=20efeff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20efeff6",
  null
  
)

export default component.exports